module.exports = __webpack_public_path__ + "static/media/icon_wifi.213910c4.svg";